import OverridesReducer from "./OverridesReducer.js";
import UserResourcesStore from "./UserResourcesStore.js";
const install = molten => {
  molten.addPlugin('DynamicStore.Reducer', OverridesReducer.createDynamicReducer());
  molten.addPlugin('Molten.LoggedIn', {
    id: 'Molten.LoggedIn.UserResourcesStore.load',
    onLoggedIn: (molten, action) => {
      return UserResourcesStore.load(action.profile.id);
    }
  });
  molten.addPlugin('Molten.LoggedOut', {
    id: 'Molten.LoggedIn.UserResourcesStore.load',
    onLoggedOut: UserResourcesStore.unload
  });
};
export default {
  install
};